/* eslint-disable jsx-a11y/control-has-associated-label */
import DP from "react-datepicker";
import fr from "date-fns/locale/fr";
import { format } from "date-fns";

import Icon from "components/Icon/Icon";

import "./DatePicker.css";

const defaultButttonStyle =
  "inline-flex p-1 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded hover:bg-primary-700 hover:text-white hover:border-primary-700 focus:outline-none focus:ring-offset-0";

export type DatePickerProps = {
  onChange?: (value: any) => void;
  value?: any;
  placeholder?: string;
  showTimeSelect?: boolean;
  timeIntervals?: number;
  minDate?: Date;
  disabled?: boolean;
};

function DatePicker({
  placeholder = "",
  value = null,
  onChange = () => {},
  showTimeSelect = true,
  timeIntervals = 15,
  minDate,
  disabled,
}: DatePickerProps) {
  const formattedValue = !value ? null : new Date(value);
  const handleChange = (newDate: Date) => onChange(newDate);

  return (
    <DP
      // dateFormat="dd/MM/yyyy HH:mm"
      dateFormat={showTimeSelect ? "dd LLL yyyy à HH:mm" : "dd LLL yyyy"}
      locale={fr}
      selected={formattedValue}
      onChange={handleChange}
      placeholderText={placeholder}
      timeIntervals={timeIntervals}
      isClearable={!disabled}
      showTimeSelect={showTimeSelect}
      portalId="date-portal"
      minDate={minDate}
      disabled={disabled}
      renderCustomHeader={({
        date,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div className="flex items-center justify-between px-2 py-2">
          <span className="font-bold capitalize text-lg text-slate-700">
            {format(date, "MMMM yyyy", { locale: fr })}
          </span>

          <div className="space-x-2">
            <button
              onClick={decreaseMonth}
              disabled={prevMonthButtonDisabled}
              type="button"
              className={`
                        ${
                          prevMonthButtonDisabled &&
                          "cursor-not-allowed opacity-50"
                        }
                        ${defaultButttonStyle}
                    `}
            >
              <Icon name="ChevronLeftIcon" className="w-4 h-4" />
            </button>

            <button
              onClick={increaseMonth}
              disabled={nextMonthButtonDisabled}
              type="button"
              className={`
                        ${
                          nextMonthButtonDisabled &&
                          "cursor-not-allowed opacity-50"
                        }
                      ${defaultButttonStyle}`}
            >
              <Icon name="ChevronRightIcon" className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}
    />
  );
}

export default DatePicker;
